import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

const localStorageKey = 'prefers-color-scheme';
const mapLocalStorageKey = 'map-color-scheme';

export enum MapColorMode {
  Auto = 'auto',
  Light = 'light',
  Dark = 'dark',
}

export const useDarkMode = defineStore('darkMode', () => {
  const enabled = ref<boolean>(getPrefersDarkMode());
  const mapColorMode = ref<MapColorMode>(getMapColorMode());

  watch(enabled, (value) => {
    localStorage.setItem(localStorageKey, value ? 'dark' : 'light');
    setDarkMode(value);
  });

  setDarkMode(enabled.value);

  function getMapColorMode(): MapColorMode {
    const item = localStorage.getItem(mapLocalStorageKey);

    if (!item) {
      return MapColorMode.Auto;
    }

    switch (item) {
      case 'auto':
        return MapColorMode.Auto;
      case 'dark':
        return MapColorMode.Dark;
      case 'light':
        return MapColorMode.Light;
      default:
        return MapColorMode.Auto;
    }
  }

  function setMapColorMode(value: MapColorMode) {
    mapColorMode.value = value;
    localStorage.setItem(mapLocalStorageKey, value);
  }

  return {
    enabled,
    mapColorMode,
    setMapColorMode,
  };
});

function setDarkMode(value: boolean) {
  document.documentElement.classList.toggle('p-dark', value);
}

function getPrefersDarkMode(): boolean {
  const item = localStorage.getItem(localStorageKey);

  switch (item) {
    case 'dark':
      return true;
    case 'light':
      return false;
  }

  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return true;
  }

  return false;
}
